import { render, staticRenderFns } from "./PeriodPriceExcelPreview.vue?vue&type=template&id=f829e27a&scoped=true&"
import script from "./PeriodPriceExcelPreview.vue?vue&type=script&lang=js&"
export * from "./PeriodPriceExcelPreview.vue?vue&type=script&lang=js&"
import style0 from "./PeriodPriceExcelPreview.vue?vue&type=style&index=0&id=f829e27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f829e27a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
